/* CNW Wishlist — localStorage hearts + wishlist page renderer (COCOTIQUE launch 24 Jul 2026) */
(function () {
  var KEY = 'cnw_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) { localStorage.setItem(KEY, JSON.stringify(list)); }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.push(handle); }
    write(list);
    return i === -1; // true = just added
  }

  function paint(btn) {
    var saved = has(btn.getAttribute('data-handle'));
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }
  function paintAll(scope) {
    var btns = (scope || document).querySelectorAll('[data-cnw-wishlist-btn]');
    for (var i = 0; i < btns.length; i++) paint(btns[i]);
  }

  /* Delegated click — works for cards, quick view modals, wishlist page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cnw-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(btn.getAttribute('data-handle'));
    paintAll();
    showToast(added, btn);
    if (document.getElementById('cnw-wishlist-grid')) renderPage();
  }, true);

  /* Toast: confirmation with a route back to the wishlist */
  var toastEl = null;
  var toastTimer = null;
  function showToast(added, btn) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cnw-wl-toast';
      toastEl.innerHTML =
        '<span class="cnw-wl-toast__msg"></span>' +
        '<a class="cnw-wl-toast__link" href="/pages/wishlist">View Wishlist</a>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.cnw-wl-toast__msg').textContent =
      added ? 'Added to Wishlist' : 'Removed from Wishlist';
    toastEl.classList.toggle('cnw-wl-toast--removed', !added);

    /* Anchor just below the tapped heart, clamped to the viewport */
    if (btn && btn.getBoundingClientRect) {
      var r = btn.getBoundingClientRect();
      toastEl.classList.add('cnw-wl-toast--anchored');
      toastEl.style.top = (r.bottom + 8) + 'px';
      toastEl.style.bottom = 'auto';
      toastEl.classList.add('cnw-wl-toast--visible');
      requestAnimationFrame(function () {
        var w = toastEl.offsetWidth;
        var left = Math.min(Math.max(12, r.right - w), window.innerWidth - w - 12);
        toastEl.style.left = left + 'px';
      });
    } else {
      toastEl.classList.remove('cnw-wl-toast--anchored');
      toastEl.style.top = '';
      toastEl.style.bottom = '';
      toastEl.style.left = '';
      toastEl.classList.add('cnw-wl-toast--visible');
    }

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('cnw-wl-toast--visible');
    }, 3200);
  }

  /* Repaint hearts on dynamically injected content (quick view modal etc.) */
  var rafPending = false;
  var observer = new MutationObserver(function () {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () { rafPending = false; paintAll(); });
  });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function renderPage() {
    var grid = document.getElementById('cnw-wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('cnw-wishlist-empty');
    var handles = read();

    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }
    if (empty) empty.style.display = 'none';

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = products.filter(Boolean).map(function (p) {
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        return (
          '<div class="cnw-wl-card">' +
            '<div class="cnw-wl-card__image">' +
              '<a href="' + p.url + '">' +
                (img ? '<img src="' + img + '&width=600" loading="lazy" alt="">' : '') +
              '</a>' +
              '<button type="button" class="cnw-wishlist-btn is-saved" data-cnw-wishlist-btn data-handle="' + p.handle + '" aria-label="Remove from wishlist" aria-pressed="true">' +
                '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21s-6.7-4.35-9.33-8.11C.9 10.34 1.7 6.6 4.66 5.3c2.05-.9 4.4-.14 5.84 1.6L12 8.6l1.5-1.7c1.44-1.74 3.79-2.5 5.84-1.6 2.96 1.3 3.76 5.04 1.99 7.59C18.7 16.65 12 21 12 21z"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="cnw-wl-card__vendor">' + (p.vendor || '') + '</div>' +
            '<a class="cnw-wl-card__title" href="' + p.url + '">' + p.title + '</a>' +
            '<div class="cnw-wl-card__price">' + money(p.price) + '</div>' +
          '</div>'
        );
      }).join('');
    });
  }

  function init() {
    paintAll();
    renderPage();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
